// Weekly streak helpers. A child's `activity` is a list of YYYY-MM-DD dates with at least one lesson step.

export const todayKey = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

// Monday-based week start for a date key
const weekStart = (key) => {
  const [y, m, d] = key.split("-").map(Number);
  const date = new Date(y, m - 1, d);
  const day = (date.getDay() + 6) % 7; // Mon=0
  date.setDate(date.getDate() - day);
  date.setHours(0, 0, 0, 0);
  return date;
};

export const weekIndex = (key) => Math.floor(weekStart(key).getTime() / (7 * 24 * 3600 * 1000));

// Lesson steps done in the current Monday-based week from a { YYYY-MM-DD: count } log
export const stepsThisWeek = (log = {}) => {
  const thisWeek = weekIndex(todayKey());
  return Object.entries(log).reduce((a, [k, v]) => (k.length === 10 && weekIndex(k) === thisWeek ? a + (Number(v) || 0) : a), 0);
};

// Bamboo earned in the current Monday-based week from a { YYYY-MM-DD: amount } log
export const bambooThisWeek = (log = {}) => {
  const thisWeek = weekIndex(todayKey());
  return Object.entries(log).reduce((a, [k, v]) => (k.length === 10 && weekIndex(k) === thisWeek ? a + (Number(v) || 0) : a), 0);
};

// Returns { weeks, activeThisWeek, lastActive, atRisk }
export const computeStreak = (activity = []) => {
  if (!activity.length) return { weeks: 0, activeThisWeek: false, lastActive: null, atRisk: false };
  const weeks = new Set(activity.map(weekIndex));
  const thisWeek = weekIndex(todayKey());
  const activeThisWeek = weeks.has(thisWeek);
  let cursor = activeThisWeek ? thisWeek : thisWeek - 1;
  let count = 0;
  while (weeks.has(cursor)) {
    count += 1;
    cursor -= 1;
  }
  const lastActive = [...activity].sort().pop();
  // at risk = has a streak from last week but nothing yet this week
  const atRisk = !activeThisWeek && count > 0;
  return { weeks: count, activeThisWeek, lastActive, atRisk };
};

export const daysSince = (key) => {
  if (!key) return null;
  const [y, m, d] = key.split("-").map(Number);
  const then = new Date(y, m - 1, d);
  return Math.floor((Date.now() - then.getTime()) / (24 * 3600 * 1000));
};
